// extracted by mini-css-extract-plugin
module.exports = {"panel":"StyleOverlay_panel__xddqq","open":"StyleOverlay_open__j_5k9"};